<template>
  <div class="con">
    <div class="head">
      <van-tabs v-model="headActive" @change="headOnChange" color="#27bec4">
        <van-tab title="卡号"></van-tab>
        <van-tab title="添加卡号"></van-tab>
        <!-- <van-tab title="建档"></van-tab> -->
      </van-tabs>
    </div>
    <!--卡列表-->
    <div class="cardflex" v-if="headActive == 0 && cardList.length != 0">
      <div class="card-list">
        <div
          class="card-li"
          v-for="(item, index) in cardList"
          @click="ChangeCard(index)"
          :class="[item.choice == '0' ? 'borActive' : '']"
          :key="index"
        >
          <div class="card-select">
            <van-icon
              v-if="item.choice == '0'"
              name="checked"
              color="#27bec4"
              size="24px"
            />
            <van-icon v-else name="circle" color="#ccc" size="24px" />
          </div>
          <div class="li-con">
            <div class="card-header">
              <span class="name-thick">{{ item.name }}</span>
              <span class="relation-tag">{{ item.relation }}</span>
            </div>
            <div class="card-info">
              <div v-if="item.brid != null && item.brid != ''">
                就诊卡号：{{ item.brid }}
              </div>
              <div v-if="item.bahm != null && item.bahm != ''">
                住院号：{{ item.bahm }}
              </div>
              <div v-if="item.sfzh != null">身份证：{{ item.sfzh }}</div>
              <div
                class="status-tag"
                :class="[
                  item.status == '正常' ? 'status-normal' : 'status-canceled',
                ]"
              >
                卡状态：{{ item.status }}
              </div>
            </div>
          </div>
          <div class="stu-Default" v-if="item.choice == '0'">默认</div>
        </div>
      </div>
    </div>
    <div
      class="bott-btn"
      v-if="radioCard != -1 && headActive == 0 && cardList.length != 0"
    >
      <div class="choose-card" @click="chooseBtn" v-if="Default == false">
        选择就诊
      </div>
      <div class="choose-card" @click="defaultBtn" v-else>选择</div>
      <div class="card-delete" @click="deleteBtn">删除卡号</div>
    </div>
    <!--绑定-->
    <div v-if="headActive == 1">
      <div v-if="radioIndex == 1" class="head-text">
        本院实行实名制，请如实填写就诊人信息，如因信息错误产生的一切后果自行负责。
      </div>
      <div v-if="radioIndex == 2" class="head-text">
        您在本院暂无就诊卡，请您申请新卡并绑定。
      </div>
      <div class="list">
        <div class="list-title">关系</div>
        <div class="list-con">
          <van-dropdown-menu>
            <van-dropdown-item v-model="value1" :options="option1" />
          </van-dropdown-menu>
        </div>
      </div>
      <div class="list" @click="showGetCard">
        <div class="list-title">姓名</div>
        <input
          type="text"
          readonly
          v-model.trim="username"
          placeholder="请输入真实姓名"
          oninput="if(value.length > 10)value=value.slice(0,10)"
        />
      </div>
      <div class="list" @click="showGetCard">
        <div class="list-title">身份证</div>
        <!-- <input type="text" v-if="idCard.length > 0" placeholder="请输入身份证号" disabled/> -->
        <input
          type="text"
          readonly
          v-model.trim="idCard"
          placeholder="请输入身份证号"
          oninput="if(value.length > 18)value=value.slice(0,18)"
        />
      </div>
      <div class="list">
        <div class="list-title">手机号</div>
        <input
          type="number"
          v-model.trim="userphone"
          placeholder="请输入手机号"
          oninput="if(value.length > 11)value=value.slice(0,11)"
        />
      </div>

      <div class="list">
        <div class="list-title">家庭住址</div>
        <input
          type="text"
          v-model.trim="useraddress"
          placeholder="请输入当前住址"
          oninput="if(value.length > 30)value=value.slice(0,30)"
        />
      </div>
      <div class="list">
        <div class="list-title">就诊卡号</div>
        <input
          type="text"
          v-model.trim="medicalCard"
          v-if="radioIndex == 1"
          placeholder="请输入就诊卡号"
          oninput="if(value.length > 20)value=value.slice(0,20)"
        />
      </div>
      <!-- <div class="radio">
				<van-radio-group v-model.trim='radioIndex' @change="onChange">
					<van-radio name="1">就诊卡</van-radio>
					<van-radio name="2">无就诊卡</van-radio>
				</van-radio-group>
				<input type="text" v-model.trim="medicalCard" v-if="radioIndex == 1" placeholder="请输入就诊卡号" oninput="if(value.length > 20)value=value.slice(0,20)" />
			</div> -->
      <!-- <div class="radio">
				<input type="text" v-model.trim="medicalCard" v-if="radioIndex == 1" placeholder="请输入就诊卡号" oninput="if(value.length > 20)value=value.slice(0,20)" />
			</div> -->
      <div class="shut-card-list" @click="shutCardListBtn" v-if="cardListShow">
        <van-icon name="cross" color="#fff" size="24px" />
      </div>
      <div class="backCCC" v-if="cardListShow" @click="shutCardListBtn"></div>
      <div class="get-card-list" v-if="cardListShow">
        <div class="input-item">
          <input type="text" v-model="username" placeholder="请输入姓名" />
        </div>
        <div class="input-item">
          <div class="input-container">
            <input
              type="text"
              v-model="tempIdCard"
              placeholder="请输入身份证号"
            />
            <div class="query-btn" @click="queryIdCard">查询</div>
          </div>
        </div>
        <div class="get-card-listbox">
          <div
            v-for="(item, index) in cardIdList"
            :key="index"
            :class="[cardBoxIndex == index ? 'cardBox-active' : '']"
            class="get-lists"
            @click="chooseCard(index)"
          >
            <div>{{ item.BRXM }}</div>
            <div v-if="item.BRID">就诊ID:{{ item.BRID }}</div>
            <div>{{ item.SFZH }}</div>
          </div>
        </div>
        <div class="confirmation" @click="chooseCardListBtn">选择</div>
      </div>
    </div>
    <!--建档-->
    <div v-if="headActive == 2">
      <div class="head-text">
        本院实行实名制，请如实填写就诊人信息，如因信息错误产生的一切后果自行负责。
      </div>
      <div class="list">
        <div class="list-title">关系</div>
        <div class="list-con">
          <van-dropdown-menu>
            <van-dropdown-item v-model="value1" :options="option1" />
          </van-dropdown-menu>
        </div>
      </div>
      <div class="list">
        <div class="list-title">姓名</div>
        <input
          type="text"
          v-model.trim="username"
          placeholder="请输入真实姓名"
          oninput="if(value.length > 10)value=value.slice(0,10)"
        />
      </div>
      <div class="list">
        <div class="list-title">身份证</div>
        <input
          type="text"
          v-model.trim="idCard"
          placeholder="请输入身份证号"
          oninput="if(value.length > 18)value=value.slice(0,18)"
        />
      </div>
      <div class="list" @click="natureBtn">
        <div class="list-title">病人性质</div>
        <input
          type="text"
          v-model.trim="nature"
          placeholder="病人性质"
          disabled
        />
      </div>
      <div class="radio">
        <van-radio-group v-model.trim="radioIndex" @change="onChangeSex">
          <van-radio name="1">男</van-radio>
          <van-radio name="2">女</van-radio>
        </van-radio-group>
      </div>
      <div class="list">
        <div class="list-title">手机号</div>
        <input
          type="number"
          v-model.trim="userphone"
          placeholder="请输入手机号"
          oninput="if(value.length > 11)value=value.slice(0,11)"
        />
      </div>

      <div class="list">
        <div class="list-title">家庭住址</div>
        <input
          type="text"
          v-model.trim="useraddress"
          placeholder="请输入当前住址"
          oninput="if(value.length > 30)value=value.slice(0,30)"
        />
      </div>

      <div class="shut-card-list" @click="shutNatureBtn" v-if="natureShow">
        <van-icon name="cross" color="#fff" size="24px" />
      </div>
      <div class="backCCC" v-if="natureShow"></div>
      <div class="get-card-list" v-if="natureShow">
        <div class="get-card-listbox">
          <div
            v-for="(item, index) in natureList"
            :key="index"
            class="get-lists"
          >
            <div
              class="nature-text"
              @click="natureChooseBtn(item.XZMC, item.BRXZ)"
            >
              {{ item.XZMC }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="headActive == 1"
      class="confirmation"
      :class="[timer != null ? 'sub-btn-ccc' : '']"
      @click="bindingBtn"
    >
      立即绑定
    </div>
    <div
      v-if="headActive == 2"
      class="confirmation"
      :class="[loginTimer != null ? 'sub-btn-ccc' : '']"
      @click="loginBtn"
    >
      建档
    </div>
    <div class="noImg" v-if="noImgShow == true && headActive == 0">
      <img src="../assets/404.gif" />
      <div class="no-text">无就诊卡~</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "patient",
  data() {
    return {
      msg: "挂号预约确认",
      noImgShow: false,
      headActive: 0, //0 、卡号 1、添加卡号 2、建档
      option1: [
        {
          text: "本人",
          value: 0,
        },
        {
          text: "他人",
          value: 1,
        },
      ],
      value1: 0,
      username: "",
      userphone: "",
      useraddress: "", //住址
      radioIndex: "1", //选择就诊卡或者身份证
      radioCard: 0, //选择卡
      medicalCard: "", //就诊卡号
      idCard: "", //身份证
      brid: "", //病人id
      cardList: [], //卡列表
      user: {},
      Default: true, //是否出现选择预约人
      userInfo: null,
      timer: null,
      cardIdList: [],
      cardBoxIndex: -1,
      cardTime: null,
      cardListShow: false,
      tempIdCard: "",
      nature: "", //病人性质
      natureNumber: "",
      natureList: [],
      sexIndex: 1, //性别 1男 2女
      loginTimer: null,
      natureShow: false,
    };
  },
  methods: {
    //建档
    loginBtn() {
      let that = this;
      clearTimeout(that.loginTimer);
      that.loginTimer = setTimeout(() => {
        //关系
        let type = that.value1;
        let typeNum;

        if (type == 0) {
          typeNum = "01";
        } else {
          typeNum = "02";
        }

        let regIdNo = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (!regIdNo.test(this.idCard)) {
          that.$toast("请填写正确的身份证格式");
          that.loginTimer = null;
          return false;
        }
        if (!/^1[3456789]\d{9}$/.test(this.userphone)) {
          that.$toast("手机号码有误");
          that.loginTimer = null;
          return false;
        }

        if (that.natureNumber == "") {
          that.$toast("病人性质不能为空");
          that.loginTimer = null;
          return false;
        }
        let url =
          "/msBrda/saveBrda?wechatId=" +
          that.userInfo.openid +
          "&portraitUrl=" +
          that.userInfo.headimgurl +
          "&wechaName=" +
          that.userInfo.nickname +
          "&name=" +
          that.username +
          "&jtdh=" +
          that.userphone +
          "&hkdz=" +
          that.useraddress +
          "&sfzh=" +
          that.idCard +
          "&brxz=" +
          that.natureNumber +
          "&brxb=" +
          that.sexIndex +
          "&csny=" +
          that.getBirthdatByIdNo(that.idCard) +
          "&relation=" +
          typeNum;
        that.$Axios
          .Post(url, null)
          .then((data) => {
            console.log(data);
            if (data.data.code == 0) {
              that.$toast.success("建档成功");
              that.GetSysPerson();
              that.username = "";
              that.userphone = "";
              that.idCard = "";
              that.useraddress = "";
              that.medicalCard = "";
              that.nature = "";
              that.natureNumber = "";
              that.noImgShow = false;
              setTimeout(function() {
                that.headActive = 0;
              }, 300);
            } else if (data.code != 0) {
              that.$toast(data.data.msg);
            }
          })
          .catch((err) => {
            that.$toast("连接服务器失败");
            console.log(err);
          });
        that.loginTimer = null;
      }, 300);
    },
    //身份证切割
    getBirthdatByIdNo(iIdNo) {
      var tmpStr = "";
      var idDate = "";
      var tmpInt = 0;
      var strReturn = "";

      iIdNo = iIdNo.replace(/^\s+|\s+$/g, "");

      if (iIdNo.length == 15) {
        tmpStr = iIdNo.substring(6, 12);
        tmpStr = "19" + tmpStr;
        tmpStr =
          tmpStr.substring(0, 4) +
          "-" +
          tmpStr.substring(4, 6) +
          "-" +
          tmpStr.substring(6);
        return tmpStr;
      } else {
        tmpStr = iIdNo.substring(6, 14);
        tmpStr =
          tmpStr.substring(0, 4) +
          "-" +
          tmpStr.substring(4, 6) +
          "-" +
          tmpStr.substring(6);
        return tmpStr;
      }
    },
    //选择性质
    natureChooseBtn(e, n) {
      this.nature = e;
      this.natureNumber = n;
      this.natureShow = false;
    },
    //性质显示按钮
    natureBtn() {
      this.natureShow = true;

      this.$Axios
        .Get("/configHis/getGyBrxz", null)
        .then((data) => {
          console.log(data);
          if (data.code == 0) {
            if (data.msg.length != 0) {
              let dataList = data.msg;
              this.natureList = dataList;
            } else {
              // that.cardIdList = [];
            }
          } else {
            this.cardIdList = [];
          }
        })
        .catch((err) => {
          this.$toast("网络出错");
          console.log(err);
        });
    },
    //关闭性质显示
    shutNatureBtn() {
      this.natureShow = false;
    },
    //检索身份证
    getUserCard(e) {
      // 不再自动触发查询，改为通过点击查询按钮触发
      this.tempIdCard = e.target.value;
    },
    // 手动查询身份证
    queryIdCard() {
      let that = this;
      let cardId = that.tempIdCard;
      let name = that.username;

      // 验证姓名和身份证号是否都已输入
      if (!name || name.trim() === "") {
        that.$toast("请输入姓名");
        return false;
      }

      let regIdNo = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (!regIdNo.test(cardId)) {
        that.$toast("请填写正确的身份证格式");
        that.cardIdList = [];
        return false;
      }

      that.$store.commit("Load", true);
      that.$Axios
        .Get(
          "/person/getBrdaList?sfzh=" + cardId + "&name=" + that.username,
          null,
        )
        .then((data) => {
          // that.$store.commit('Load', false)
          if (data.code == 0) {
            if (data.msg.length != 0) {
              let dataList = data.msg;
              that.cardIdList = dataList;
              that.$toast.success("找到" + dataList.length + "条记录");
            } else {
              that.cardIdList = [];
              that.$toast("没有您的档案，请先建档");
            }
          } else {
            that.cardIdList = [];
            that.$toast("查询失败，请重试");
          }
          that.$store.commit("Load", false);
        })
        .catch((err) => {
          that.$toast("网络出错");
          // this.noImgShow = true;
          that.$store.commit("Load", false);
          console.log(err);
        });

      // 只在输入完成后更新主表单的身份证号
      if (cardId.length === 15 || cardId.length === 18) {
        this.idCard = cardId;
      }
    },
    //选择身份证改变
    chooseCardListBtn() {
      if (this.cardBoxIndex != -1) {
        let dataList = this.cardIdList[this.cardBoxIndex];
        this.username = dataList.BRXM;
        this.userphone = dataList.JTDH;
        this.idCard = dataList.SFZH;
        this.medicalCard = dataList.MZHM;
        this.useraddress = dataList.HKDZ;
        this.brid = dataList.BRID;

        this.$toast.success("选择成功");
        // 延迟关闭弹窗，让用户看到成功提示
        setTimeout(() => {
          this.cardListShow = false;
          // 自动聚焦到手机号输入框
          this.$nextTick(() => {
            let phoneInput = document.querySelector(
              'input[placeholder="请输入手机号"]',
            );
            if (phoneInput) {
              phoneInput.focus();
            }
          });
        }, 800);
      } else {
        this.$toast("请选择一个卡号");
      }
    },
    //选择身份证改变样式
    chooseCard(e) {
      if (this.cardBoxIndex == e) {
        return false;
      }
      this.cardBoxIndex = e;
    },
    //关闭身份证检索框
    shutCardListBtn() {
      this.cardListShow = false;
    },
    //显示身份证检索框
    showGetCard() {
      this.cardIdList = [];
      this.cardListShow = true;
      this.cardBoxIndex = -1;
      // 自动聚焦到身份证输入框
      this.$nextTick(() => {
        let idCardInput = document.querySelector(".get-card-list input");
        if (idCardInput) {
          idCardInput.focus();
        }
      });
    },
    //性别选择
    onChangeSex(e) {
      if (this.sexIndex == e) {
        return false;
      }
      this.sexIndex = e;
    },
    //顶部导航
    headOnChange(event) {
      this.headActive = event;

      this.username = "";
      this.userphone = "";
      this.idCard = "";
      this.medicalCard = "";
      this.useraddress = "";
      this.nature = "";

      // 切换到添加卡号tab时，弹出身份证查询窗口
      if (event === 1) {
        this.showGetCard();
      }
    },
    //选择身份证或者就诊卡
    onChange(e) {
      if (e == 1) {
      } else {
        this.medicalCard = "";
      }
      this.radioIndex = e;
    },
    //列表卡选择
    ChangeCard(e) {
      this.radioCard = e;
      let cardList = this.cardList;
      for (let i = 0, len = cardList.length; i < len; i++) {
        cardList[i].choice = "1";
      }
      this.cardList[e].choice = "0";
    },
    //默认使用
    defaultBtn() {
      this.$Axios
        .Post(
          "/person/updateSysPerson?wechatId=" +
            this.userInfo.openid +
            "&id=" +
            this.cardList[this.radioCard].id +
            "&choice=0",
          null,
        )
        .then((data) => {
          console.log(data);
          if (data.data.code == 0) {
            localStorage.setItem(
              "cardUserInfo",
              JSON.stringify(this.cardList[this.radioCard]),
            );
            this.$toast.success("选择成功");
            this.$router.go(-1);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取微信挂号人员信息
    GetSysPerson() {
      this.$store.commit("Load", true);
      let userInfo = this.userInfo;

      this.$Axios
        .Get("/person/sysPerson?wechatId=" + userInfo.openid, null)
        .then((data) => {
          console.log(data);
          this.$store.commit("Load", false);
          if (data.code == 0) {
            if (data.msg.length != 0) {
              let dataList = data.msg;

              dataList.map((value, i) => {
                value.relation = value.relation == "01" ? "本人" : "他人";
                value.status = value.status == "1" ? "正常" : "已注销";
                if (value.choice == 0) {
                  this.radioCard = i;
                  for (let j in userInfo) {
                    value[j] = userInfo[j];
                  }
                  localStorage.setItem("cardUserInfo", JSON.stringify(value));
                }
              });

              this.cardList = dataList;
              this.noImgShow = false;
            } else {
              this.noImgShow = true;
            }
          } else {
            this.cardList = "";
            this.noImgShow = true;
          }
        })
        .catch((err) => {
          this.$toast("网络出错");
          this.noImgShow = true;
          this.$store.commit("Load", false);
          console.log(err);
        });
    },
    //立即绑定
    bindingBtn() {
      let that = this;
      //关系
      let type = this.value1;
      let typeNum;

      if (type == 0) {
        typeNum = "01";
      } else {
        typeNum = "02";
      }

      if (!/^1[3456789]\d{9}$/.test(this.userphone)) {
        this.$toast("手机号码有误");
        that.timer = null;
        return false;
      }
      let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (reg.test(this.idCard) === false) {
        this.$toast("身份证输入不合法");
        that.timer = null;
        return false;
      }
      if (that.medicalCard == "") {
        this.$toast("就诊卡不能为空");
        that.timer = null;
        return false;
      }
      clearTimeout(that.timer);
      that.timer = setTimeout(() => {
        let url =
          "/person/addSysPerson?wechatId=" +
          that.userInfo.openid +
          "&portraitUrl=" +
          that.userInfo.headimgurl +
          "&wechaName=" +
          that.userInfo.nickname +
          "&relation=" +
          typeNum +
          "&name=" +
          that.username +
          "&phone=" +
          that.userphone +
          "&address=" +
          that.useraddress +
          "&brkh=" +
          that.medicalCard +
          "&sfzh=" +
          that.idCard +
          "&brid=" +
          that.brid;
        that.$Axios
          .Post(url, null)
          .then((data) => {
            console.log(data);
            if (data.data.code == 0) {
              that.$toast.success("添加成功");
              that.GetSysPerson();
              that.username = "";
              that.userphone = "";
              that.idCard = "";
              that.useraddress = "";
              that.medicalCard = "";
              that.noImgShow = false;
              setTimeout(function() {
                that.headActive = 0;
              }, 300);
            } else if (data.code != 0) {
              that.$toast(data.data.msg);
            }
          })
          .catch((err) => {
            that.$toast("连接服务器失败");
            console.log(err);
          });
        that.timer = null;
      }, 500);
    },
    //选择就诊人
    chooseBtn() {
      let card = this.cardList[this.radioCard];
      let user = this.user;
      for (let i in card) {
        user[i] = card[i];
      }
      this.$router.replace({
        path: "/regConfirmation",
        query: {
          user: JSON.stringify(user),
        },
      });
    },
    //删除
    deleteBtn() {
      let that = this;
      this.$dialog
        .confirm({
          title: "删除",
          message: "确定删除卡号？",
        })
        .then(() => {
          let url =
            "/person/delSysPerson?wechatId=" +
            this.cardList[this.radioCard].wechatId +
            "&id=" +
            this.cardList[this.radioCard].id;
          this.$Axios
            .Post(url, null)
            .then((data) => {
              console.log(data);
              if (data.data.code == 0) {
                this.$toast("删除成功");
                setTimeout(() => {
                  that.radioCard = -1;
                  that.GetSysPerson();
                  localStorage.setItem("cardUserInfo", "");
                }, 300);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
  },
  watch: {
    "$store.state.token": {
      handler(newVal, oldVal) {
        console.log("token变化监听触发:", newVal, oldVal);
        if (newVal && newVal !== oldVal) {
          console.log("token更新，重新获取用户信息");
          this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
          this.GetSysPerson();
        }
      },
      immediate: true, // 立即执行一次
      deep: true,
    },
  },
  mounted() {
    // if(JSON.stringify(this.$route.query.user) != undefined) { //如果不是挂号跳转过来的页面
    //  console.log(JSON.parse(this.$route.query.user))
    //  let us = JSON.parse(this.$route.query.user);
    //  this.user = us;
    //  this.Default = false; //不出现选择预约按钮
    // }

    if (this.$store.state.token) {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.GetSysPerson();
    }
  },
};
</script>

<style scoped>
.noImg {
  margin-top: 10vh;
  text-align: center;
}

.no-text {
  margin-top: 10px;
  color: #27bec4;
  font-size: 16px;
}

.head-text {
  padding: 5px 10px;
  background: #dcdee0;
  font-size: 12px;
  text-indent: 2em;
}

.card-li {
  position: relative;
  display: flex;
  align-items: flex-start;
  width: 90%;
  margin: 12px auto;
  background: #fff;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  padding: 15px;
  transition: all 0.3s ease;
}
.card-li:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}
.card-select {
  margin-right: 15px;
  margin-top: 5px;
}
.name-thick {
  font-size: 16px;
  color: #000000;
  font-weight: 600;
  margin-right: 10px;
}
.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.relation-tag {
  padding: 3px 10px;
  background-color: #f0f0f0;
  border-radius: 12px;
  font-size: 12px;
  color: #666;
}
.card-info {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}
.card-info div {
  margin: 5px 0;
}
.status-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 8px;
  font-size: 12px;
  margin-top: 8px;
}
.status-normal {
  background-color: rgba(39, 190, 196, 0.1);
  color: #27bec4;
}
.status-canceled {
  background-color: rgba(255, 0, 0, 0.1);
  color: #ff0000;
}
.stu-Default {
  padding: 6px;
  position: absolute;
  right: -30px;
  top: 15px;
  width: 120px;
  background-color: #27bec4;
  font-size: 14px;
  color: #fff;
  text-align: center;
  transform: rotate(45deg);
  font-weight: 600;
}

.con {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
}

.cardflex {
  overflow: auto;
  flex: 1;
  padding: 10px 0;
}

.card-list {
  flex: 1;
  overflow-y: auto;
}

.van-radio {
  width: 100%;
}

.van-radio >>> .van-radio__label {
  width: 100%;
}

.li-con {
  flex: 1;
}

.li-con div {
  margin: 5px 0;
}

.list {
  width: 90%;
  margin: 10px auto;
}

.list-con {
  background: #fff;
}

.list-title {
  margin: 10px 0;
  font-size: 16px;
  color: #27bec4;
  font-weight: 600;
}

.list input,
.radio input {
  padding: 10px;
  width: 90%;
  font-size: 14px;
  border: 1px solid #999;
}

.radio {
  margin: 20px;
}

.van-radio-group {
  display: flex;
  justify-content: space-around;
  margin: 20px;
}

.confirmation {
  margin: 0 auto;
  padding: 10px 0;
  width: 90%;
  color: #fff;
  background-color: #27bec4;
  border-radius: 10px;
  text-align: center;
  font-size: 16px;
}

.bott-btn {
  display: flex;
  justify-content: space-around;
  font-size: 16px;
  padding: 15px;
  gap: 15px;
}

.choose-card {
  padding: 15px 0;
  background: #27bec4;
  color: #fff;
  width: 50%;
  text-align: center;
  border-radius: 12px;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(39, 190, 196, 0.2);
}

.choose-card:hover {
  background: #1aacc0;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(39, 190, 196, 0.3);
}

.card-delete {
  padding: 15px 0;
  background: #ff4d4f;
  color: #fff;
  width: 50%;
  text-align: center;
  border-radius: 12px;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(255, 77, 79, 0.2);
}

.card-delete:hover {
  background: #ff7875;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 77, 79, 0.3);
}

.borActive {
  border: 1px solid #27bec4;
}
.sub-btn-ccc {
  background-color: #ccc;
}
.shut-card-list {
  padding: 10px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 20px;
  margin: auto;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #ff0000;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}
.shut-card-list:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}
.backCCC {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0.5;
  z-index: 5;
}
.get-card-list {
  padding: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 85%;
  max-width: 400px;
  height: 70%;
  background-color: #fff;
  z-index: 10;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
}
.input-item {
  margin-bottom: 15px;
}
.input-label {
  margin-bottom: 5px;
  font-size: 14px;
  color: #27bec4;
  font-weight: 600;
}
.input-container {
  display: flex;
  gap: 10px;
  margin-top: 5px;
}
.get-card-list input {
  padding: 12px 16px;
  flex: 1;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  transition: border-color 0.3s ease;
  width: 100%;
}
.input-item input {
  padding: 12px 16px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  transition: border-color 0.3s ease;
  width: 90%;
  max-width: 90%;
  display: block;
}
.input-item {
  margin-bottom: 15px;
  width: 100%;
}
.query-btn {
  padding: 12px 20px;
  background-color: #27bec4;
  color: #fff;
  border-radius: 8px;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  transition: all 0.3s ease;
  cursor: pointer;
  white-space: nowrap;
}
.query-btn:hover {
  background-color: #1aacc0;
  box-shadow: 0 2px 8px rgba(39, 190, 196, 0.3);
}
.query-btn:active {
  transform: translateY(1px);
}
.get-card-list input:focus {
  outline: none;
  border-color: #27bec4;
  box-shadow: 0 0 0 2px rgba(39, 190, 196, 0.2);
}
.get-card-listbox {
  width: 100%;
  flex: 1;
  overflow-y: auto;
  margin-bottom: 15px;
  padding: 10px;
  border-radius: 8px;
  background-color: #f5f5f5;
}
.get-lists {
  padding: 15px;
  margin: 10px 0;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #fff;
  transition: all 0.3s ease;
  cursor: pointer;
}
.get-lists:hover {
  border-color: #27bec4;
  box-shadow: 0 2px 8px rgba(39, 190, 196, 0.1);
}
.cardBox-active {
  border: 1px solid #27bec4;
  background-color: #27bec4;
  color: #fff;
  box-shadow: 0 2px 8px rgba(39, 190, 196, 0.3);
}
.confirmation {
  padding: 12px;
  background-color: #27bec4;
  color: #fff;
  border-radius: 8px;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  transition: all 0.3s ease;
  cursor: pointer;
}
.confirmation:hover {
  background-color: #1aacc0;
  box-shadow: 0 2px 8px rgba(39, 190, 196, 0.3);
}
.confirmation:active {
  transform: translateY(1px);
}
.nature-text {
  margin: 10px;
  font-size: 18px;
}
</style>
